export enum InputType
{
    None,
    CreditCards,
    BalanceTransfer,
    Mortgages,
    PersonalLoans,
    SavingsAccounts,
}